import {Component, OnInit, ViewChild} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {ServicesService} from '../services.service';
import {HttpErrorResponse} from '@angular/common/http';
import {environment} from '../../environments/environment';
import { Router } from '@angular/router';
import swal from 'sweetalert2';

@Component({
  selector: 'app-product',
  templateUrl: './product.component.html',
  styleUrls: ['./product.component.css']
})
export class ProductComponent implements OnInit {

    apiBaseUrl: string = environment.apiBaseUrl;
    header = 'l-header';
    navbar = 'l-navbar l-navbar_t-light l-navbar_expand js-navbar-sticky';
    cartArertHide = true;
    requiredProductText = 'REQUIRED';
    shootName;
    clientName;
    jobid;
    marginTop = '0%';
    requiedProductData = [];
    additionalProductData = [];
    freeShipmentTimeLeftr;
    freeShipmentTimeLefta;
    freeShipmentTimeLeftFlag;
    productExpire = true;

  constructor(private route: ActivatedRoute, private _service: ServicesService, private router: Router) {
      this.route.params.subscribe( params => {
          this.jobid = params['jobid'];
       });
  }

  ngOnInit() {
      // alert("test");
     /* this.route.queryParams.subscribe(params => {
          this.jobid = params['jobid'];
      });*/
      this.getJob();
  }

  getJob() {
      this._service.getJob(this.jobid).subscribe((data: any) => {
          // console.log('all', data);
          if (data.result.length > 0)
          {
              // console.log('client_id', data.result[0].client_id);
              const client_id = data.result[0].client_id;
              this._service.getClientName(client_id).subscribe((clientObj: any) => {
                    // console.log('ClientObj', clientObj);
                    this.clientName = clientObj.result[0].name;

                  $('.tb-preloader-wave').fadeOut();
                  $('#tb-preloader').delay(200).fadeOut('slow').remove();
              });
              data.result.map((item, index) => {
                  this.shootName = item['shoot_name'];
                  this.freeShipmentTimeLeftFlag = item['freeShipmentTimeLeftFlag'];
                  if (item['is_saleable']) {
                      this.requiedProductData.push(item);
                      this.marginTop = '5%';
                      this.freeShipmentTimeLeftr = item['freeShipmentTimeLeft'];
                  } else {
                      this.additionalProductData.push(item);
                      this.freeShipmentTimeLefta = item['freeShipmentTimeLeft'];
                  }
              });
          }else {
              this.productExpire = false;
          }
         // console.log('requiedProductData', this.requiedProductData);
         // console.log('additionalProductData', this.additionalProductData);
          },    (err: HttpErrorResponse) => { });

  }

  addToCart() {
    this.cartArertHide = false;
  }

    checkAdditionalProductAddToCart(job_id, product_id) {
        const userData = JSON.parse(localStorage.getItem('userData'));
        // userData.hasOwnProperty('id')
        const user_id = userData ? userData.id : '';
        const obj = {job_id: job_id, product_id: product_id, user_id: user_id};
      //  console.log(obj);
        this._service.checkAdditionalProductAddToCart(obj).subscribe( (data: any) => {

            if (data.result === 1) {
                // console.log(data);
                this.router.navigate(['newphotoselection'],{ queryParams: { jobid: job_id, product_id: product_id }});
            }else {
                swal({
                    title: 'Oops!',
                    text: 'Please add the required products to your cart first in order to unlock the additional products',
                    type: 'warning',
                    confirmButtonText: 'Ok',
                });

            }
        });
    }

}



// WEBPACK FOOTER //
// /var/www/html/oneills-web-qa/src/app/product/product.component.ts